<p-confirmpopup class="globalPopup" [key]="key()" styleClass="customPopup" #confirmPopupRef>
  <ng-template #headless let-message let-test>
    <div class="border-round p-3">
      <span>{{ message.message }}</span>
      <div class="flex align-items-center gap-2 mt-3">
        <p-button (click)="accept()" [label]="translate.instant('common.yes')" size="small" />
        <p-button (click)="reject()" [label]="translate.instant('common.no')" [outlined]="true" size="small" />
      </div>
    </div>
  </ng-template>
</p-confirmpopup>
